import { pickerController } from '@ionic/core'

interface IConfig {
  areas: any[];
  areaId: number;
  callback: (data: any) => void;
}

class DeskAreaPickController {
  public isPickInit: boolean

  constructor () {
    this.isPickInit = false
  }

  async showPicker (config: IConfig) {
    const { areas = [], areaId, callback } = config
    const options = areas.map(item => ({ value: item.id, text: item.name }))
    const index = areas.findIndex(item => item.value === areaId)
    if (this.isPickInit) return
    this.isPickInit = true
    const picker = await pickerController.create({
      cssClass: 'common-picker-modal desk-area-modal',
      columns: [
        {
          name: 'area',
          selectedIndex: index < 0 ? 0 : index,
          options,
        },
      ].filter(Boolean),
      buttons: [
        {
          text: i18n.t('common.ok'),
          handler: (value) => {
            callback && callback(value.area)
          }
        }
      ]
    })
    picker.addEventListener('ionPickerWillPresent', (ev) => {
      const pickerWrapper = document.querySelector('ion-picker.desk-area-modal .picker-wrapper')
      const pickerToolbar = pickerWrapper.querySelector('.picker-toolbar')
      const pickerHeader = document.createElement('div')
      pickerHeader.classList.add('picker-header')
      pickerHeader.innerHTML = `
        <div class='title'>
          <span>${i18n.t('queue.selectArea')}</span>
          <i class='iconfont icon-close'></i>
        </div>
        <div class='subtitle'>${i18n.t('queue.selectAreaTip')}</div>
      `
      pickerHeader.querySelector('i').addEventListener('click', () => {
        picker.dismiss()
      }, true)
      pickerWrapper.insertBefore(pickerHeader, pickerToolbar)
    })

    await picker.present()
    this.isPickInit = false
    return () => {
      picker.dismiss()
    }
  }
}

export default DeskAreaPickController
